export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBCBaT0xGn6Ouytoi4ZLQbmbHx1UACQus0',
    authDomain: 'regionesicilia-crowdsense-dev.firebaseapp.com',
    projectId: 'regionesicilia-crowdsense-dev',
    storageBucket: 'regionesicilia-crowdsense-dev.appspot.com',
    messagingSenderId: '274382693963',
    appId: '1:274382693963:web:24ee0a8f580c6e041ccfce',
  },
  apiPath: '/api/v1',
  API: {
    mocked: 'assets/mocks',
  },
  basemap: {
    osm: 'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
    darkCarto: 'https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png',
  },
  logoutTimeout: 3600,
  warningTimeout: 3300,
};
